import { ICellRendererParams } from '@ag-grid-community/core';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { getCurrentBalances, showCcyCurrentBalanceAmount, showSecurityCurrentBalanceAmount } from '@tassat/ag-grid';
import { TransactionStatusCode } from '@tassat/common-definitions';
import { TransactionHistoryRecord } from '@tassat/fred-extended-definitions';
import { formatAsAsset } from '@tassat/utility';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getAssetFromTicker } from 'Selectors/assets';

interface FormatCurrentAmountProps extends ICellRendererParams {
    data: TransactionHistoryRecord;
}

const muiStyles = makeStyles({ cell: { fontSize: '13px' }});

export const FormatCurrentAmount = (props: FormatCurrentAmountProps) => {
    const { data } = props;
    const asset = useAppSelector((state) => getAssetFromTicker(state, props.data?.Ticker));
    const classes = muiStyles();

    if (
        data.Status === TransactionStatusCode.REJECTED ||
        data.Status === TransactionStatusCode.FAILED ||
        data.Status === TransactionStatusCode.REQ_PENDING ||
        data.Status === TransactionStatusCode.PENDING
    ) {
        return <>-</>;
    }
    if (!asset) return <></>;

    const showSecurityAmount = showSecurityCurrentBalanceAmount(asset, data);
    const showCcyAmount = showCcyCurrentBalanceAmount(asset, data);
    const balances = getCurrentBalances(data);

    return (
        <Grid
            container
            direction='column'
        >
            {showCcyAmount ?
                (
                    <Typography
                        className={classes.cell}
                    >
                        {formatAsAsset(balances.fiatBalance, {
                            ...asset,
                            DecimalPoint: 2
                        }, 'curcode')}
                    </Typography>
                )
                : null}
            {showSecurityAmount && (balances.assetBalance || balances.assetBalance === 0) ?
                (
                    <Typography
                        className={classes.cell}
                    >
                        {formatAsAsset(balances.assetBalance, asset, 'ticker', undefined, true)}
                    </Typography>
                )
                : null}
        </Grid>
    );
};

export default FormatCurrentAmount;